<template>
    <div class="modal" ref="sendBulkEmail" id="sendBulkEmail" role="dialog" data-backdrop="static" data-keyboard="false">
        <div v-if="modalFlag" class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
            <div class="modal-content">
                <div class="modal-header font-bold bg-teal text-white">
                    <h5 class="modal-title font-weight-bold" id="exampleModalCenterTitle">Send Bulk Email</h5>
                    <button type="button" class="close text-black" data-dismiss="modal" aria-label="Close" @click="closeModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body bg-white">
                    <div class="flex">
                        <div class="stepper-wrapper" style="width: 80%;">
                            <div v-for="step in steps" class="stepper-item"
                                 :class="[(currentStep > step.stepCount ? 'completed' : ''), (currentStep === step.stepCount ? 'active' : '')]">
                                <div class="step-counter"></div>
                                <div class="step-name">{{ step.name }}</div>
                            </div>
                        </div>
                        <div>
                            <span class="step-counter-text">Step {{ currentStep }} of {{ steps.length }}</span>
                        </div>
                    </div>
                    <div class="flex justify-content-between">
                        <div class="bg-grey-lighter rounded-full w-1/3 flex items-center">
                            <input ref="filter" type="search"
                                   class="bg-grey-lighter text-grey-darkest w-5/6 focus:outline-none p-1 rounded-full ml-3 text-sm"
                                   placeholder="Search by name..." @input="debounceFilter" v-model="filter">
                            <div class="flex-1 text-right pr-3">
                                <i v-if="data_loading" class="fa fa-spin fa-spinner text-grey-darkest"
                                   aria-hidden="true"></i>
                            </div>
                        </div>
                        <b-button class="bg-primary float-right" pill variant="info"
                                  @click.stop.prevent="toggleModal">New Template
                        </b-button>
                    </div>
                    <div class="flex justify-content-between">
                        <div class="text-grey-darkest font-weight-bold flex-1 float-left pr-3 mt-3 ml-1">
                            <!--                            <h6>-->
                            <!--                                {{ checked_project_ids.length ? checked_project_ids.length : checked_contact_ids.length ? checked_contact_ids.length : 0 }} contact(s) will be emailed-->
                            <!--                                <span class="text-primary pointer underline pl-1" @click="openCustomizeModal">Customize</span>-->
                            <!--                            </h6>-->
                        </div>
                    </div>
                    <div class="bg-white shadow-md rounded mb-6 mt-3">
                        <table class="text-left w-full border-collapse">
                            <thead>
                            <tr>
                                <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer"
                                    :class="{'text-primary font-weight-bold':sort.column === 'template_name'}"
                                    @click="sortBy('template_name')">
                                    Template Name
                                </th>
                                <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer"
                                    :class="{'text-primary font-weight-bold':sort.column === 'last_used'}"
                                    @click="sortBy('last_used')">
                                    Last Used
                                </th>
                                <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer"
                                    :class="{'text-primary font-weight-bold': sort.column === 'last_modified'}"
                                    @click="sortBy('last_modified')">
                                    Last Update
                                </th>
                                <th class="py-1 px-3 bg-grey-lightest font-medium uppercase text-xs text-grey-darkest border-b border-grey-light cursor-pointer">
                                    Action
                                </th>
                                <th class="bg-grey-lightest border-b border-grey-light"></th>
                            </tr>
                            </thead>
                            <tbody v-if="allTemplates.length > 0">
                            <tr class="hover:bg-grey-lighter cursor-pointer border-b-1"
                                v-for="(template, idx) in allTemplates" :key="idx" :class="{'bg-grey font-weight-bold': (selectedTemplate && selectedTemplate.id && selectedTemplate.id === template.id)}">
                                <td class="text-xs pl-2 py-1 px-3" style="word-break: break-all">
                                    <div>
                                        {{ template.template_name }}
                                    </div>
                                </td>
                                <td class="text-xs pl-2 px-3">
                                    <div>{{ template.last_used }}</div>
                                </td>
                                <td class="text-xs pl-2 px-3">
                                    <div>{{ template.last_modified }}</div>
                                </td>
                                <td class="text-xs pl-2 px-3">
                                    <button type="button"
                                            class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer"
                                            :class="{'text-primary font-weight-bold': (selectedTemplate && selectedTemplate.id && selectedTemplate.id === template.id)}"
                                            @click="(selectedTemplate && selectedTemplate.id && selectedTemplate.id === template.id) ? removeTemplateToPreview() : addTemplateToPreview(template)">
                                        {{ (selectedTemplate && selectedTemplate.id && selectedTemplate.id === template.id) ? 'check' : 'add' }}
                                    </button>
                                    <button @click="editTemplate(template)"
                                            class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer">
                                        edit
                                    </button>
                                    <button type="button"
                                            class="material-icons text-base text-grey-darkest hover:text-grey-darkest focus:outline-none hover:cursor-pointer"
                                            @click="destroyTemplate(template.id)">delete
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr class="border-b-1">
                                <td colspan="4" class="text-center p-4">No Template Found</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-if="pagination.meta.total > pagination.meta.per_page" class="flex justify-center">
                        <b-pagination
                            @change="goToPage"
                            v-model="pagination.meta.current_page"
                            :total-rows="pagination.meta.total"
                            :per-page="pagination.meta.per_page"
                            first-text="First"
                            prev-text="Prev"
                            next-text="Next"
                            last-text="Last">
                        </b-pagination>
                    </div>
                </div>

                <div class="modal-footer flex justify-content-between">
                    <div>
                        <button class="btn custom-border" data-dismiss="modal" aria-label="Close" @click="closeModal()">Cancel</button>
                        <button v-if="currentStep > 1" class="btn custom-border" @click.prevent="backToTemplateStep">Back</button>
                    </div>
                    <div class="row">
                        <button class="btn btn-primary mr-2" v-on="isContactType ? { click: () => nextContactTypeModal() } : { click: () => togglePreviewModal() }">{{ isContactType ? 'Next' : 'Preview' }}</button>
                    </div>
                </div>
                <!--                <div class="modal-footer flex justify-content-between">-->
                <!--                    <button class="btn custom-border" data-dismiss="modal" aria-label="Close" @click="closeModal()">Cancel</button>-->
                <!--                    <div class="row">-->
                <!--                        <button class="btn btn-primary mr-2" @click="togglePreviewModal">Preview</button>-->
                <!--                    </div>-->
                <!--                </div>-->
            </div>
        </div>
        <div v-else-if="isPreview" class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md">
            <div class="modal-content">

                <div class="modal-header font-bold bg-teal text-white">
                    <h5 class="modal-title font-weight-bold">Send Bulk Email</h5>
                    <button type="button" class="close text-black" data-dismiss="modal" aria-label="Close" @click="closeModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body text-grey-darkest">
                    <div class="px-1 flex flex-wrap flex-lg-nowrap items-stretch">
                        <div class="mb-4 text-grey-darkest">
                            <div class="flex">
                                <div class="stepper-wrapper" style="width: 80%;">
                                    <div v-for="step in steps" class="stepper-item"
                                         :class="[((currentStep > step.stepCount || currentStep === steps.length) ? 'completed' : ''), (currentStep === step.stepCount ? 'active' : '')]">
                                        <div class="step-counter"></div>
                                        <div class="step-name">{{ step.name }}</div>
                                    </div>
                                </div>
                                <div>
                                    <span class="step-counter-text">Step {{ currentStep }} of {{ steps.length }}</span>
                                </div>
                            </div>
                            <div class="mb-4 text-grey-darkest text-sm">Subject: {{ selectedTemplate && selectedTemplate.subject ? selectedTemplate.subject : '' }}</div>

                            <div class="preview-email-template"
                                 v-html="this.previewSelectedTemplate()">
                            </div>
                        </div>
                    </div>

                </div>

                <div class="modal-footer flex justify-content-between">
                    <div>
                        <button class="btn custom-border" data-dismiss="modal" aria-label="Close" @click="closeModalPreviewStage()">Cancel</button>
                        <button class="btn custom-border" @click.prevent="togglePreviewBack">Back</button>
                    </div>
                    <button class="btn btn-primary" @click="sendEmail">Send</button>
                </div>

            </div>
        </div>
        <div v-else class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
            <div class="modal-content">

                <div class="modal-header font-bold bg-teal text-white">
                    <h5 class="modal-title font-weight-bold">Send Bulk Email</h5>
                    <button type="button" class="close text-black" data-dismiss="modal" aria-label="Close" @click="closeModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body text-grey-darkest">
                    <div class="px-1 flex flex-wrap flex-lg-nowrap items-stretch">
                        <div class="flex-col w-full pr-4">
                            <div class="text-grey-darkest text-base text mb-8 border-b-2 border-followup-nav pl-4 pb-2">
                                {{ isUpdateTemplate ?  'Edit Template' : 'Add Template' }}
                            </div>
                            <div class="flex flex-row justify-content-between px-4">
                                <div class="mb-3 w-full">
                                    <label class="text-grey-darkest">Template Name</label>
                                    <input v-model="emailTemplateObj.template_name" id="template_name"
                                           title="template_name" maxlength="64"
                                           class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"/>
                                    <span style="color: red" v-if="errorFlag">{{ error.template_name }}</span>
                                </div>
                            </div>
                            <div class="flex flex-row justify-content-between px-4">
                                <div class="mb-3 w-full">
                                    <label class="text-grey-darkest">Subject</label>
                                    <input v-model="emailTemplateObj.subject" id="subject"
                                           title="template_name" maxlength="64"
                                           class="bg-white leading-normal tracking-wide appearance-none border-1 rounded py-1 px-2 text-grey-darkest w-full focus:outline-none"/>
                                    <span style="color: red" v-if="errorFlag">{{ error.subject }}</span>
                                </div>
                            </div>
                            <div class="flex flex-row justify-content-between px-4">
                                <div class="mb-3 w-full">
                                    <label class="text-grey-darkest">Insert Fields</label>
                                    <multiselect
                                        id="selectFields"
                                        :options="allFields"
                                        :multiple="false"
                                        :close-on-select="true"
                                        :clear-on-select="true"
                                        :preserve-search="false"
                                        :taggable="false"
                                        open-direction="below"
                                        placeholder="Select field to add in editor"
                                        :showLabels="false"
                                        label="text"
                                        track-by="id"
                                        :preselect-first="false"
                                        @select="fieldSelected"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                            <div class="flex flex-row justify-content-between px-4">
                                <div class="mb-3 w-full">
                                    <label class="text-grey-darkest">Template</label>
                                    <ckeditor-template id="comment" v-model="emailTemplateObj.template_text" :user="user"
                                                       mentionFrom="name"></ckeditor-template>
                                    <!--                                        <vue-text-editor :textBinding="emailTemplateObj.template_text" v-on:emailBodyText="emailBodyText"></vue-text-editor>-->
                                    <span style="color: red" v-if="errorFlag">{{ error.template_text }}</span>
                                </div>
                            </div>
                            <div class="flex flex-row justify-content-between px-4">
                                <b-button class="bg-primary float-right" pill variant="info"
                                          @click.stop.prevent="addTemplate()">{{ isUpdateTemplate ?  'Update' : 'Create' }}
                                </b-button>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="modal-footer flex justify-content-between">
                    <button class="btn custom-border" data-dismiss="modal" aria-label="Close" @click="closeModal()">Cancel</button>
                    <button class="btn btn-primary" @click="toggleModal">Close</button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Form from "../../../utils/form";
import Multiselect from 'vue-multiselect';

export default {
    name: 'bulk-email-project',
    props: {
        checked_project_ids: { type: Array },
        checked_contact_ids: { type: Array },
        selectedContactTypesForBulkEmail: { type: Array },
    },
    components: { Multiselect },

    data() {
        return {
            loadingUpdate: false,
            selectedTemplate: null,
            allTemplates: [],
            form: new Form({
                project_ids: [],
                contact_ids: [],
                template_id: null,
            }),
            modalFlag: true,
            emailTemplateObj: {
                id: null,
                template_name: '',
                template_text: '',
                template_type: 'bulk_email_project',
                subject: '',
            },
            error: {
                template_name: '',
                template_text: '',
                subject: ''
            },
            errorFlag: false,
            // allFields: [],
            customFields: [],
            projectFields: [
                {
                    id: 0,
                    button: 'addYourName',
                    text: 'Your Name',
                    buttonCode: 'replaceYourName'
                },
                {
                    id: 1,
                    button: 'addFirstName',
                    text: 'First Name',
                    buttonCode: 'replaceFirstName'
                },
                {
                    id: 2,
                    button: 'addProjectName',
                    text: 'Project Name',
                    buttonCode: 'replaceProjectName'
                },
                {
                    id: 3,
                    button: 'addAddress',
                    text: 'Address',
                    buttonCode: 'replaceAddress'
                },
                {
                    id: 4,
                    button: 'addCity',
                    text: 'City',
                    buttonCode: 'replaceCity'
                },
                {
                    id: 5,
                    button: 'addState',
                    text: 'State',
                    buttonCode: 'replaceState'
                },
                {
                    id: 6,
                    button: 'addZip',
                    text: 'Zip',
                    buttonCode: 'replaceZip'
                },
                {
                    id: 7,
                    button: 'addContact',
                    text: 'Contact',
                    buttonCode: 'replaceContact'
                },
                {
                    id: 8,
                    button: 'addEmail',
                    text: 'Email',
                    buttonCode: 'replaceEmail'
                },
                {
                    id: 9,
                    button: 'addPhone',
                    text: 'Phone',
                    buttonCode: 'replacePhone'
                },
                {
                    id: 10,
                    button: 'addBaseBid',
                    text: 'Base Bid',
                    buttonCode: 'replaceBaseBid'
                },
                {
                    id: 11,
                    button: 'addContractAmount',
                    text: 'Contract Amount',
                    buttonCode: 'replaceContractAmount'
                },
                {
                    id: 12,
                    button: 'addContractDate',
                    text: 'Contract Date',
                    buttonCode: 'replaceContractDate'
                },
                {
                    id: 13,
                    button: 'addGrossMargin',
                    text: 'Gross Margin',
                    buttonCode: 'replaceGrossMargin'
                },
                {
                    id: 14,
                    button: 'addLabourHours',
                    text: 'Labour Hours',
                    buttonCode: 'replaceLabourHours'
                },
                {
                    id: 15,
                    button: 'addDeadDate',
                    text: 'Dead Date',
                    buttonCode: 'replaceDeadDate'
                },
                {
                    id: 16,
                    button: 'addSalesStatus',
                    text: 'Sales Status',
                    buttonCode: 'replaceSalesStatus'
                },
                {
                    id: 17,
                    button: 'addMarketingStatus',
                    text: 'Marketing Status',
                    buttonCode: 'replaceMarketingStatus'
                },
                {
                    id: 18,
                    button: 'addPrebid',
                    text: 'Pre Bid',
                    buttonCode: 'replacePrebid'
                },
                {
                    id: 19,
                    button: 'addBidDate',
                    text: 'Bid Date',
                    buttonCode: 'replaceBidDate'
                },
                {
                    id: 20,
                    button: 'addLeadSource',
                    text: 'Lead Source',
                    buttonCode: 'replaceLeadSource'
                },
                {
                    id: 21,
                    button: 'addEstimator',
                    text: 'Estimator',
                    buttonCode: 'replaceEstimator'
                },
                {
                    id: 22,
                    button: 'addAccountManager',
                    text: 'Account Manager',
                    buttonCode: 'replaceAccountManager'
                },
                {
                    id: 23,
                    button: 'addTakeOffPerson',
                    text: 'Take Off Person',
                    buttonCode: 'replaceTakeOffPerson'
                },
                {
                    id: 24,
                    button: 'addProductAndServices',
                    text: 'Product And Services',
                    buttonCode: 'replaceProductAndServices'
                },
                {
                    id: 25,
                    button: 'addClientProfile',
                    text: 'Client Profile',
                    buttonCode: 'replaceClientProfile'
                },
                {
                    id: 26,
                    button: 'addContractType',
                    text: 'Contract Type',
                    buttonCode: 'replaceContractType'
                },
                {
                    id: 27,
                    button: 'addOffice',
                    text: 'Office',
                    buttonCode: 'replaceOffice'
                },
                {
                    id: 28,
                    button: 'addCell',
                    text: 'Cell',
                    buttonCode: 'replaceCell'
                },
                {
                    id: 29,
                    button: 'addFax',
                    text: 'Fax',
                    buttonCode: 'replaceFax'
                }
            ],
            contactFields: [
                {
                    id: 0,
                    button: 'addYourName',
                    text: 'Your Name',
                    buttonCode: 'replaceYourName'
                },
                {
                    id: 1,
                    button: 'addFirstName',
                    text: 'First Name',
                    buttonCode: 'replaceFirstName'
                },
                {
                    id: 2,
                    button: 'addName',
                    text: 'Name',
                    buttonCode: 'replaceName'
                },
                {
                    id: 3,
                    button: 'addPhone',
                    text: 'Phone',
                    buttonCode: 'replacePhone'
                },
                {
                    id: 4,
                    button: 'addEmail',
                    text: 'Email',
                    buttonCode: 'replaceEmail'
                },
                {
                    id: 5,
                    button: 'addCompanyName',
                    text: 'Company Name',
                    buttonCode: 'replaceCompanyName'
                },
                {
                    id: 6,
                    button: 'addTitle',
                    text: 'Title',
                    buttonCode: 'replaceTitle'
                },
                {
                    id: 7,
                    button: 'addType',
                    text: 'Type',
                    buttonCode: 'replaceType'
                },
                {
                    id: 8,
                    button: 'addFollowUp',
                    text: 'Follow Up',
                    buttonCode: 'replaceFollowUp'
                },
                {
                    id: 9,
                    button: 'addLastUpdated',
                    text: 'Last Updated',
                    buttonCode: 'replaceLastUpdated'
                }
            ],
            isPreview: false,
            page: 1,
            filter: '',
            sort: {
                direction: 'desc',
                column: 'id'
            },
            pagination: {
                data: [],
                meta: {},
                links: {},
            },
            data_loading: true,
            isUpdateTemplate: false,
            user: {},
            selectedContactTypes: [],
            isContactType: true,
            steps: [
                { name: 'Select Template', stepCount: 1 },
                { name: 'Select Contact Type', stepCount: 2 },
                { name: 'Preview', stepCount: 3 }
            ],
            currentStep: 1
        }
    },
    mounted() {
        this.fetchTemplates();
        $("#bulkEmailModal").on('hidden.bs.modal', () => this.clear());
        this.fetchCustomFields();

        let self = this;
        Bus.$on('close-customize-modal-data', function() {
            self.isContactType = false;
        });
        Bus.$on('bulk-email-modal-current-step', function(data) {
            self.currentStep = data;
        });
    },
    watch:{
        emailTemplateObj: {
            immediate: false,
            handler: function (emailObjVal, oldVal) {
                if(emailObjVal.template_name!==""){
                    this.error.template_name='';
                }
            },
            deep: true
        },
        selectedContactTypesForBulkEmail: {
            immediate: true,
            handler: function() {
                this.$nextTick(() => {
                    this.selectedContactTypes = this.selectedContactTypesForBulkEmail;
                });
            }
        }
    },
    methods: {
        fieldSelected(selectedOption, id) {
            let data = [];
            data['button'] = selectedOption.button;
            data['text'] = selectedOption.text;
            data['buttonCode'] = selectedOption.buttonCode;
            Bus.$emit("fieldAddedToEditor", data);
        },
        addTemplate() {
            if(this.checked_contact_ids.length > 0) {
                this.emailTemplateObj.template_type = 'bulk_email_contact'
            }else if(this.checked_project_ids.length > 0) {
                this.emailTemplateObj.template_type = 'bulk_email_project'
            }
            const templateName = this.emailTemplateObj.template_name;
            const templateText = this.emailTemplateObj.template_text;
            const subject = this.emailTemplateObj.subject;
            if(!templateName && !templateText){
                this.errorFlag = true;
                this.error.template_name = 'Template name is required';
                this.error.template_text = 'Template text is required';
                return false;
            }
            if (!templateName) {
                this.errorFlag = true;
                this.error.template_name = 'Template name is required';
                return false;
            }
            if(!templateText){
                this.errorFlag = true;
                this.error.template_text = 'Template text is required';
                return false;
            }
            if(!subject){
                this.errorFlag = true;
                this.error.subject = 'Email subject is required';
                return false;
            }
            axios.post(route('api.template.store'), this.emailTemplateObj).then(({data}) => {
                if (data.success) {
                    this.modalFlag = true;
                    this.allTemplates = data.data.data;
                    this.data_loading = false;
                    this.isUpdateTemplate = false;
                    this.selectedTemplate = null;
                }
            });
        },
        open() {
            $(this.$el).modal('show');
            this.modalFlag = true;
            this.form.project_ids = [ ...this.checked_project_ids ];
            this.form.contact_ids = [ ...this.checked_contact_ids ];
        },

        fetchTemplates() {
            let params = {
                filter: this.filter,
                column: this.sort.column,
                direction: this.sort.direction,
                page: this.page,
                template_type: (this.checked_project_ids.length > 0) ? 'bulk_email_project': 'bulk_email_contact'
            }
            this.data_loading = true;
            axios.get(route('api.template.index'), {params}).then(({data}) => {
                this.allTemplates = data.data;
                this.pagination = data;
                this.data_loading = false;
            })
        },
        toggleModal(){
            this.modalFlag = !this.modalFlag;
            this.emailTemplateObj.template_name = '';
            this.emailTemplateObj.subject = '';
            this.emailTemplateObj.template_text = '';
            this.isUpdateTemplate = false;
        },
        fetchCustomFields() {
            axios.get(route('api.project-custom-field.index')).then(({data}) => {

                let counter = 29;
                this.customFields = data.data.map(field => {
                    const fieldName = field.label_value.replace(/\s+/g, '')
                    counter++;
                    return {
                        id: counter,
                        button: 'add'+fieldName,
                        text: field.label_value,
                        buttonCode: 'replace'+fieldName
                    }
                });
                // this.allFields = this.projectFields.concat(this.customFields);
            });
        },
        togglePreviewModal() {
            if(this.selectedTemplate === null) {
                this.getToast().fire({
                    type: 'error',
                    title: "Please choose a template first!"
                });
                return false;
            }
            this.modalFlag = false;
            this.isPreview = true;
        },
        togglePreviewBack() {
            this.modalFlag = true;
            this.isPreview = false;
            $("#sendBulkEmail").modal("show");
        },
        previewSelectedTemplate() {
            let text = '';
            if(this.selectedTemplate) {
                text = this.selectedTemplate.template_text;

                this.allFields.forEach(item => {
                    text = text.replace('<span><span class="'+item.button+' projectDataShow" disabled="disabled" style="pointer-events: none;border: 1px solid #01b1af;font-size: 12px;padding: 1px 5px;color: #01b1af;text-align: center;width: 170px;margin-right:5px;maring-left:5px">'+item.text+'</span><span class="projectDataHidden">$'+item.buttonCode+'</span></span>', '{{ '+item.text+' }}')
                });
            }

            return text;
        },
        sendEmail() {

            if(this.checked_project_ids.length > 0 || this.checked_contact_ids.length > 0) {
                if(this.selectedTemplate === null) {
                    this.getToast().fire({
                        type: 'error',
                        title: "Please choose a template first!"
                    });
                    return false;
                }

                let params = {
                    template_id: this.selectedTemplate.id,
                    project_ids: this.checked_project_ids ?? [],
                    contact_ids: this.checked_contact_ids ?? [],
                    selected_contact_types: this.selectedContactTypes
                };
                axios.post(route('api.project.bulk-email'), params).then(({data}) => {
                    $(this.$el).modal('hide');
                    if(data.status === true) {
                        this.getToast().fire({
                            type: 'success',
                            title: data.message,
                        });
                        this.closeModal();
                    }
                    else if(data.status === false) {
                        this.getToast().fire({
                            type: 'error',
                            title: data.message,
                        });
                    }
                });

            } else {
                if(this.checked_project_ids.length === 0) {
                    this.getToast().fire({
                        type: 'error',
                        title: "Please check projects first!"
                    });
                    return false;

                } else if(this.checked_contact_ids.length === 0) {
                    this.getToast().fire({
                        type: 'error',
                        title: "Please check contacts first!"
                    });
                    return false;
                }
            }
        },

        goToPage(page) {
            this.page = page;
            this.fetchTemplates();
        },

        debounceFilter: _.debounce(function (e) {
            this.filter = e.target.value;
            this.goToPage(1)
        }, 700),

        sortBy(column) {
            this.sort.direction = this.sort.column === column ? (this.sort.direction === 'asc' ? 'desc' : 'asc') : 'asc';
            this.sort.column = column;
            this.goToPage(1);
        },

        addTemplateToPreview(template) {
            this.selectedTemplate = {
                id: template.id,
                subject: template.subject,
                template_name: template.template_name,
                template_text: template.template_text,
                team_id: template.team_id,
                last_used: template.last_used,
                last_modified: template.last_modified,
            }

            if(this.selectedTemplate !== null) {
                this.getToast().fire({
                    type: "success",
                    title: "Template has been added."
                });
            } else {
                this.getToast().fire({
                    type: "error",
                    title: "Template not added."
                });
            }
        },

        removeTemplateToPreview() {
            this.selectedTemplate = null;

            if(this.selectedTemplate === null) {
                this.getToast().fire({
                    type: "success",
                    title: "Template has been removed."
                });
            } else {
                this.getToast().fire({
                    type: "error",
                    title: "Template not removed."
                });
            }
        },

        editTemplate(template) {
            this.modalFlag = !this.modalFlag;
            this.isUpdateTemplate = true;
            this.emailTemplateObj = {
                id: template.id,
                subject: template.subject,
                template_name: template.template_name,
                template_text: template.template_text,
            }
        },

        destroyTemplate(id) {
            axios.post(route('api.destroy-bulk-email-template'),  { 'id': id }).then(({data}) => {
                if(data.success) {
                    this.getToast().fire({
                        type: "success",
                        title: data.message
                    });
                    this.selectedTemplate = null;
                    this.fetchTemplates();
                } else {
                    this.getToast().fire({
                        type: "error",
                        title: data.message
                    });
                }
            });
        },

        closeModal() {
            this.selectedTemplate = null;
            this.isUpdateTemplate = false;
            this.isPreview = false;
            this.isContactType = true;
            this.filter = '';
            this.currentStep = 1;
            this.goToPage(1);
        },
        openCustomizeModal() {
            Bus.$emit('open-customize-modal');
        },
        nextContactTypeModal() {
            if(this.selectedTemplate === null) {
                this.getToast().fire({
                    type: 'error',
                    title: "Please choose a template first!"
                });
                return false;
            }

            this.currentStep += 1;
            Bus.$emit('next-contact-type-modal-current-step', this.currentStep, this.steps.length);
            this.openCustomizeModal();
        },
        backToTemplateStep() {
            this.currentStep = 1;
            this.isContactType = true;
            this.selectedTemplate = null;
        },
        closeModalPreviewStage() {
            $("#sendBulkEmail").modal("hide");
            this.selectedTemplate = null;
            this.isUpdateTemplate = false;
            this.isPreview = false;
            this.isContactType = true;
            this.filter = '';
            this.currentStep = 1;
            this.goToPage(1);
        }
    },
    computed: {
        allFields() {
            if(this.checked_project_ids.length > 0) {
                return this.projectFields.concat(this.customFields)
            } else if(this.checked_contact_ids.length > 0) {
                return this.contactFields;
            }
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.custom-border {
    border: 1px solid !important;
}
.preview-email-template {
    height: 210px;
    width: 458px;
    padding: 7px;
    border: 1px solid #ccc;
    overflow: auto;
}
.stepper-wrapper {
    margin-top: auto;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}
.stepper-item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 1;
    @media (max-width: 768px) {
        font-size: 12px;
    }
}
.stepper-item::before {
    position: absolute;
    content: "";
    border-bottom: 2px solid #ccc;
    width: 100%;
    top: 9px;
    left: -50%;
    z-index: 2;
}
.stepper-item::after {
    position: absolute;
    content: "";
    border-bottom: 2px solid #ccc;
    width: 100%;
    top: 9px;
    left: 50%;
    z-index: 2;
}
.stepper-item .step-counter {
    position: relative;
    z-index: 5;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #ccc;
    margin-bottom: 6px;
}
.stepper-item.active {
    font-weight: bold;
}
.stepper-item.active .step-name {
    color: #3d4852;
}
.stepper-item.completed .step-counter {
    background-color: #01b1af;
}
.stepper-item.completed .step-name {
    color: #01b1af;
}
.stepper-item.completed::after {
    position: absolute;
    content: "";
    border-bottom: 2px solid #01b1af;
    width: 100%;
    top: 9px;
    left: 50%;
    z-index: 3;
}
.stepper-item:first-child::before {
    content: none;
}
.stepper-item:last-child::after {
    content: none;
}
.step-counter-text {
    font-size: 15px;
    font-weight: 600;
}
</style>
